import { render, staticRenderFns } from "./TicketCreate.vue?vue&type=template&id=805b3d72&scoped=true&"
import script from "./TicketCreate.vue?vue&type=script&lang=js&"
export * from "./TicketCreate.vue?vue&type=script&lang=js&"
import style0 from "./TicketCreate.vue?vue&type=style&index=0&id=805b3d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805b3d72",
  null
  
)

export default component.exports